// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectionList__Rs1fJucrrR{max-height:400px;overflow:auto}`, "",{"version":3,"sources":["webpack://./src/components/customFields/baseCustomFieldSelect/baseCustomFieldSelect.module.scss"],"names":[],"mappings":"AAAA,2BACE,gBAAA,CACA,aAAA","sourcesContent":[".selectionList {\n  max-height: 400px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionList": `selectionList__Rs1fJucrrR`
};
export default ___CSS_LOADER_EXPORT___;
